import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../hooks/useTranslations';
import { activateBusinessAreaFilter, activateNewsCategoryFilter, activateSpecialFilter, deactivateBusinessAreaFilter, deactivateNewsCategoryFilter, deactivateSpecialFilter, selectActiveBusinessAreaFilters, selectActiveNewsCategoryFilters, selectActiveSpecialFilters, selectBusinessAreasFilters, selectFilteredNews, selectNewsCategoryFilters, selectSpecialFilters } from '../../../../redux/modules/data/newsSlice';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import { PopoverItem } from '../../layouts/partials/PopupWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import TableWrapper from '../../layouts/partials/TableWrapper';
import PrivateLayout from '../../layouts/PrivateLayout';
import NewsListRow from './partials/NewsListRow';

const NewsListScreen = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const filteredNews = useSelector((state) => selectFilteredNews(state));

	const allNewsCategories = useSelector((state) => selectNewsCategoryFilters(state));
	const activeNewsCategoryFilters = useSelector((state) => selectActiveNewsCategoryFilters(state));

	const allBusinessAreaFilters = useSelector((state) => selectBusinessAreasFilters(state));
	const activeBusinessAreaFilters = useSelector((state) => selectActiveBusinessAreaFilters(state));

	const allSpecialFilters = useSelector((state) => selectSpecialFilters(state));
	const activeSpecialFilters = useSelector((state) => selectActiveSpecialFilters(state));

	const toggleNewsCategoryItem = ({ id, isActive }) => {
		if (isActive) {
			dispatch(deactivateNewsCategoryFilter({ categoryId: id }));
		} else {
			dispatch(activateNewsCategoryFilter({ categoryId: id }));
		}
	};

	const toggleBusinessAreaFilter = ({ id, isActive }) => {
		if (isActive) {
			dispatch(deactivateBusinessAreaFilter({ businessAreaId: id }));
		} else {
			dispatch(activateBusinessAreaFilter({ businessAreaId: id }));
		}
	};

	const toggleSpecialFilter = ({ id, isActive }) => {
		if (isActive) {
			dispatch(deactivateSpecialFilter({ special: id }));
		} else {
			dispatch(activateSpecialFilter({ special: id }));
		}
	};

	const newsCategoriesPopoverItems = allNewsCategories?.map((newsCategory) => (<PopoverItem key={newsCategory.id} id={newsCategory.id} title={newsCategory.title} isActive={activeNewsCategoryFilters.includes(newsCategory.id)} callback={toggleNewsCategoryItem} />));
	const businessAreaPopoverItems = allBusinessAreaFilters?.map((businessArea) => (<PopoverItem key={businessArea.id} id={businessArea.id} title={businessArea.title} isActive={activeBusinessAreaFilters.includes(businessArea.id)} callback={toggleBusinessAreaFilter} />));
	const specialPopoverItems = allSpecialFilters?.map((specialFilter) => (<PopoverItem key={specialFilter.id} id={specialFilter.id} title={specialFilter.title} isActive={activeSpecialFilters.includes(specialFilter.id)} callback={toggleSpecialFilter} />));

	const activeBusinessAreaFiltersCount = activeBusinessAreaFilters.filter((filterId) => filterId !== 'all').length;
	const activeNewsCategoryFiltersCount = activeNewsCategoryFilters.filter((filterId) => filterId !== 'all').length;
	const activeSpecialFiltersCount = activeSpecialFilters.filter((filterId) => filterId !== 'all').length;
	const baFilterCount = activeBusinessAreaFiltersCount > 0 ? ` (${activeBusinessAreaFiltersCount})` : '';
	const catFilterCount = activeNewsCategoryFiltersCount > 0 ? ` (${activeNewsCategoryFiltersCount})` : '';
	const specialFilterCount = activeSpecialFiltersCount > 0 ? ` (${activeSpecialFiltersCount})` : '';

	const mainButtons = [
		{ id: 1, title: t('webapp_news_filter_bas'), dynamicTitlePart: baFilterCount, popoverItems: businessAreaPopoverItems },
		{ id: 2, title: t('webapp_news_filter_cats'), dynamicTitlePart: catFilterCount, popoverItems: newsCategoriesPopoverItems },
		{ id: 3, title: t('webapp_news_filter_misc'), dynamicTitlePart: specialFilterCount, popoverItems: specialPopoverItems },
	];

	const breadcrumb = [
		{ route: 'news', translationKey: 'news_button' },
	];

	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={t('news_headline')} customTree={breadcrumb} />
			<ContentWrapper>
				<TableWrapper buttons={mainButtons} title={filteredNews?.length === 0 ? t('no_news_found') : ''}>
					{filteredNews?.length > 0 && (
						<div className="border-t-0.5 border-b-0.5 divide-y divide-oly-gray-light border-oly-gray-light">
							{filteredNews.map((news) => <NewsListRow key={news.id} news={news} />)}
						</div>
					)}
				</TableWrapper>
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default NewsListScreen;
